import React from 'react'
import Page from '../../components/Page'
import { useLanguageState } from '../../globalStates/LanguageState'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState'
import LogoSection from './LogoSection'
import VideoSection from './VideoSection'
import BasicInfoSection from './BasicInfoSection'
import DescriptionSection from './DescriptionSection'
import KeywordsSection from './KeywordsSection'
import SocialMediaSection from './SocialMediaSection'
import ConsentContentSection from './ConsentContentSection'
import FrameSection from './FrameSection'
import { useConfigDataState } from '../../globalStates/ConfigDataState'
import { hasServiceKeys } from '../../globalStates/ConfigDataState'
import CompanySortSection from './CompanySortSection'

function buildPageTitle(base: string, companyName: string) {
    return `${base} ${companyName}`
}

const ProfilePage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organization = useExhibitorDataState().getOrganization()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const logoVisible = hasServiceKeys(serviceKeys.logo)
    const headerVideoVisible = hasServiceKeys(serviceKeys.headerVideo)
    const headerGraphicVisible = hasServiceKeys(serviceKeys.headerGraphic)
    const socialMediaVisible = hasServiceKeys(serviceKeys.socialMedia)
    const keywordsVisible = hasServiceKeys(serviceKeys.keywords)
    const iframeVisible = hasServiceKeys(serviceKeys.iframe)
    const consentVisible = hasServiceKeys(serviceKeys.consent)
    return (
        <Page
            title={buildPageTitle(branding.configuration.profilePage.pageTitle, organization.name.get())}
            description={branding.configuration.profilePage.pageDescription}>
            {(logoVisible || headerGraphicVisible) && <LogoSection />}
            {headerVideoVisible && <VideoSection />}
            <BasicInfoSection />
            <CompanySortSection organizationState={organization} />
            <DescriptionSection />
            {keywordsVisible && <KeywordsSection />}
            {socialMediaVisible && <SocialMediaSection />}
            {iframeVisible && <FrameSection />}
            {consentVisible && <ConsentContentSection />}
        </Page>
    );
}

export default ProfilePage
